import { Box } from "@mui/material";
import Checkbox from "@mui/material/Checkbox";
import { format } from "date-fns";
import React from "react";
import { useDispatch } from "react-redux";

import { selectWorkerReassignment } from "../../../../store/full-time-shifts-slice";
import TruncatedText from "../../truncated-text";

const BORDER_COLOR = "#DEDEDE";

const getTimeRange = (startDate: string, endDate: string) => {
  const start = new Date(startDate);
  const end = new Date(endDate);
  return `${format(start, "h:mm a")} - ${format(end, "h:mm a")}`;
};

export const WorkerShiftCard = ({ reassignment }: any) => {
  const { startDate, endDate, to, from, id, isSelected } = reassignment;
  const dispatch = useDispatch();

  const isPatternChangedForThisShift = to.patternId !== from.patternId;
  const isJobChangedForThisShift = to.jobId !== from.jobId;
  const isWorkcenterChangedForThisShift = to.workCenterId !== from.workCenterId;

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        borderRadius: "8px",
        border: `1px solid ${BORDER_COLOR}`,
        backgroundColor: "#FAFAFA",
        padding: 1,
        maxWidth: "100%",
        width: "100%",
        height: "100%",
        cursor: "pointer",
      }}
      onClick={() => {
        dispatch(selectWorkerReassignment(id));
      }}
    >
      <Box
        sx={{
          fontSize: "12px",
          fontFamily: "Roboto",
          color: "rgba(0,0,0,0.87)",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          maxWidth: "100%",
        }}
      >
        <TruncatedText
          text={getTimeRange(startDate, endDate)}
          tooltipDisabled={false}
          style={{
            fontSize: "12px",
            fontFamily: "Roboto",
            color: "rgba(0,0,0,0.87)",
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            maxWidth: "100%",
          }}
        />
        <Checkbox
          size="small"
          checked={isSelected}
          sx={{ padding: 0 }}
        />
      </Box>
      <TruncatedText
        text={to.patternName}
        tooltipDisabled={false}
        style={{
          fontSize: "12px",
          fontFamily: "Roboto",
          color: isPatternChangedForThisShift ? "rgba(0,0,0,0.87)" : "rgba(0,0,0,0.6)",
          fontWeight: isPatternChangedForThisShift ? 500 : 400,
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
          maxWidth: "100%",
        }}
      />
      <TruncatedText
        text={to.jobName}
        tooltipDisabled={false}
        style={{
          fontSize: "12px",
          fontFamily: "Roboto",
          color: isJobChangedForThisShift ? "rgba(0,0,0,0.87)" : "rgba(0,0,0,0.6)",
          fontWeight: isJobChangedForThisShift ? 500 : 400,
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
          maxWidth: "100%",
          marginTop: "2px",
        }}
      />
      <Box
        sx={{
          display: "inline-block",
          px: "8px",
          borderRadius: "16px",
          backgroundColor: "#E3E6ED",
          maxWidth: "100%",
          width: "fit-content",
          marginTop: "4px",
          boxShadow: "inset 0 1px 1px rgba(255,255,255,0.6), 0 1px 2px rgba(0,0,0,0.05)",
        }}
      >
        <TruncatedText
          text={to.workCenterName}
          tooltipDisabled={false}
          style={{
            fontSize: "12px",
            fontFamily: "Roboto",
            color: isWorkcenterChangedForThisShift ? "rgba(0,0,0,0.87)" : "rgba(0,0,0,0.6)",
            fontWeight: isWorkcenterChangedForThisShift ? 500 : 400,
            whiteSpace: "nowrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            maxWidth: "100%",
          }}
        />
      </Box>
    </Box>
  );
};
